import type { Theme } from "@mui/material";
import MuiButton from "./MuiButton";
import MuiIconButton from "./MuiIconButton";
import MuiListItem from "./MuiListItem";
import MuiListItemText from "./MuiListItemText";
import MuiPaper from "./MuiPaper";
import MuiTableCell from "./MuiTableCell";
import MuiFilledInput from "./MuiFilledInput";
import MuiInputLabel from "./MuiInputLabel";
import MuiCard from "./MuiCard";
import MuiInputBase from "./MuiInputBase";
import MuiTab from "./MuiTab";
import MuiLink from "./MuiLink";
import MuiTabs from "./MuiTabs";
import MuiCircularProgress from "./MuiCircularProgress";
import MuiDialog from "./MuiDialog";
import MuiAppBar from "./MuiAppBar";
import MuiChip from "./MuiChip";
// eslint-disable-next-line import/no-anonymous-default-export

const getPortalRoot = () => document.getElementById("root") ?? document.body;

const components = (theme: Theme) => ({
  MuiButton: MuiButton(theme),
  MuiIconButton: MuiIconButton(),
  MuiListItemText: MuiListItemText(),
  MuiListItem: MuiListItem(theme),
  MuiCard: MuiCard(),
  MuiPaper: MuiPaper(theme),
  MuiTableCell,
  MuiInputLabel: MuiInputLabel(theme),
  MuiFilledInput,
  MuiInputBase: MuiInputBase(theme),
  MuiTabs: MuiTabs(theme),
  MuiTab: MuiTab(theme),
  MuiLink: MuiLink(theme),
  MuiCircularProgress: MuiCircularProgress(),
  MuiDialog: MuiDialog(),
  MuiAppBar: MuiAppBar(theme),
  MuiDrawer: {
    defaultProps: {
      ModalProps: {
        container: getPortalRoot,
      },
    },
    // Lift temporary (overlay) drawers into the modal band (zIndex.modal = 1300) so they render
    // ABOVE the impersonation bar (theme.zIndex.drawer + 20..25 = 1220-1225) instead of being
    // painted over by it. Permanent/persistent drawers (e.g. the unified side nav) stay in the
    // drawer band (1200) so the bar can still sit above them.
    styleOverrides: {
      root: ({ ownerState }: { ownerState: { variant?: string } }) => ({
        ...(ownerState.variant === "temporary" && {
          zIndex: theme.zIndex.modal,
        }),
      }),
    },
  },
  MuiChip: MuiChip(theme),
});
export default components;
